import axios from 'axios';
import Jsona from 'jsona';
import store from "../../store";
import router from "@/router";

const url = process.env.VUE_APP_API_BASE_URL;
const jsona = new Jsona();

function get() {
  return axios.get(`${url}/me`)
  //return axios.get('${url}/me')
    .then(response => {
      
      console.log("response")
      return {
        
        list: jsona.deserialize(response.data),
        meta: response.data.meta
      };
    }).catch(function(error) {
      if (error.response && error.response.status === 401) {
        if (!store.getters.isAuthenticated) {
          
          router.push({ name: "Login" });
        }
        else{
          
        store.dispatch("logout");
        }
        // router.push({ name: "Login" });
        console.log("not found")
        return {
        
          list: null,
          meta: null
        };
        
      } else {
       // console.log("kkkkkkkkkk")
      }
    });;
}

function update(profile) {
  console.log(profile);
  const payload = jsona.serialize({
    stuff: profile,
    includeNames: []
  });
  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };

  return axios.patch(`${url}/me`, payload, options)
  //return axios.patch('${url}/me', payload, options)
    .then(response => {
      
      return jsona.deserialize(response.data);
    });
}

export default {
  get,
  update
};
